import Button from './Button'
import Reveal from './Reveal'
import { LogoMark } from './Logo'
import { company } from '../data/site'
import { hy } from '../lib/typography'

/**
 * The closing call to action.
 *
 * Every page of the old site ended with the heading "Optimieren Sie Ihre
 * Immobilienverwaltung jetzt!" and a "Termin vereinbaren" button, so the rebuild
 * keeps it - with the phone number added, because the original band offered no
 * second way to get in touch. Both strings can be overridden per page.
 */
export default function CtaBand({
  title = `Optimieren Sie Ihre ${hy('Immobilien', 'verwaltung')} jetzt!`,
  text = 'Fragen Sie ein kostenloses Erstgespräch an. Wir sehen uns Ihr Objekt an und sagen Ihnen offen, was wir für Sie übernehmen können.',
}) {
  return (
    <section className="cta-band on-dark">
      <div className="blueprint" aria-hidden="true" />
      <LogoMark
        className="watermark"
        size={420}
        style={{ right: '-4rem', bottom: '-8rem' }}
      />
      <div className="container">
        <Reveal className="cta-band__inner">
          <div>
            <h2 className="cta-band__title">{title}</h2>
            <p className="cta-band__text">{text}</p>
          </div>
          <div className="btn-row">
            <Button to="/kontakt" icon="arrowRight">
              Termin vereinbaren
            </Button>
            <Button
              href={company.phoneHref}
              variant="ghost-dark"
              iconBefore="phone"
            >
              {company.phone}
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
